<div class="modal-content">
	<form (ngSubmit)="onSubmit()" #requestExport="ngForm">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Exportacion de datos</div>
				<div *ngIf="!useGridFilters" class="modal-wizard-desc">Indique rango de fechas y tipo de exportacion.</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="closeModal()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>

		<div class="modal-body">
			<div *ngIf="useGridFilters" class="export-grid-info">
				<div class="export-grid-info-title">Exportacion segun grilla</div>
				<div class="export-grid-info-text">
					Se exportaran los DTEs que coinciden con los filtros aplicados en la barra de busqueda de Documentos Emitidos.
				</div>
				<div class="export-grid-info-hint">
					Antes de iniciar la descarga, revisa el resumen previo y confirma la exportacion.
				</div>
			</div>

			<div class="form-group row mx-1" *ngIf="!useGridFilters">
				<div class="col-4 label-control pt-3">Rango de Fechas</div>
				<div class="col-6">
					<input type="text" name="dateExportacion" [maxDate]="todayString" ngxDaterangepickerMd [locale]="locale" (change)="detectExportChangeDate($event)" (input)="detectExportChangeDate($event)" [(ngModel)]="dateExportacion" class="form-control" [singleDatePicker]="false" [autoApply]="true" [autocomplete]="false" [showDropdowns]="true" />
					<div *ngIf="requestExport.submitted && (dateExportacion.startDate == null || dateExportacion == '' || !validDate)" class="invalid-feedback-group">
						<div *ngIf="dateExportacion.startDate == null">Campo requerido</div>
						<div *ngIf="!validDate && locale.format == 'MM/YYYY'">Fecha invalida, use el formato dd/mm/yyyy</div>
					</div>
				</div>
			</div>

			<div class="form-group row mx-1 mt-3">
				<label class="col-4 label-control pt-3" for="exportType">Tipo de Exportacion</label>
				<div class="col-6 d-flex justify-content-start align-items-center">
					<div class="form-check form-check-inline mr-6">
						<input type="radio" class="form-check-input" id="excelRadio" name="exportType" [value]="'excel'" [(ngModel)]="exportType" (ngModelChange)="onExportTypeChange()" required />
						<label class="form-check-label" for="excelRadio">Excel</label>
					</div>
					<div *ngIf="type !== 999" class="form-check form-check-inline mr-6">
						<input type="radio" class="form-check-input" id="xmlRadio" name="exportType" [value]="'xml'" [(ngModel)]="exportType" (ngModelChange)="onExportTypeChange()" required />
						<label class="form-check-label" for="xmlRadio">XML</label>
					</div>
				</div>
			</div>

			<div *ngIf="useGridFilters && summaryError" class="alert alert-danger py-2 mt-3 mb-0">
				{{ summaryError }}
			</div>
		</div>

		<div class="modal-footer d-flex align-items-center p-3">
			<div class="form-text text-muted mr-auto col-md-8">
				<p *ngIf="type === 999">El rango maximo permitido es de 1 año, independiente de la fecha actual.</p>
				<p>El rango maximo permitido es de {{ isSuperAdmin ? '2 años' : '6 meses' }}, independiente de la fecha actual.</p>
			</div>
			<div>
				<button *ngIf="!useGridFilters" type="submit" id="add-contact-item" class="btn btn-success">
					<i class="la la-paper-plane-o d-lg-none"></i>
					<span class="d-none d-lg-block">Exportar</span>
				</button>
				<button *ngIf="useGridFilters" type="button" class="btn btn-success" (click)="openSummaryModal()" [disabled]="loadingSummary">
					<span *ngIf="loadingSummary" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
					<i *ngIf="!loadingSummary" class="la la-search d-lg-none"></i>
					<span>{{ loadingSummary ? 'Cargando resumen...' : 'Ver resumen' }}</span>
				</button>
				<button type="button" class="btn btn-secondary ml-3" (click)="closeModal()">
					<span class="d-none d-lg-block">Cancelar</span>
				</button>
			</div>
		</div>
	</form>
</div>

<ng-template #summaryStepModal let-modal>
	<div class="modal-header">
		<div class="modal-wizard-label">
			<div class="modal-wizard-title">Resumen previo de exportacion</div>
			<div class="modal-wizard-desc">Revise el detalle y confirme la exportacion.</div>
		</div>
		<button type="button" class="close" aria-label="Close" (click)="closeSummaryModal(modal)">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>

	<div class="modal-body">
		<div class="d-flex justify-content-between align-items-center mb-2">
			<h6 class="mb-0">Resumen previo</h6>
		</div>

		<div *ngIf="loadingSummary" class="text-muted">Cargando resumen de exportacion...</div>
		<div *ngIf="summaryError" class="alert alert-danger py-2 mb-2">{{ summaryError }}</div>

		<div *ngIf="!loadingSummary && !summaryError">
			<table class="table table-sm table-bordered mb-2" *ngIf="summaryRows.length > 0">
				<thead>
					<tr>
						<th>Concepto</th>
						<th class="text-right">Cantidad</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of summaryRows" [class.export-summary-total-row]="row.isTotal">
						<td>{{ row.concepto }}</td>
						<td class="text-right">{{ row.cantidad }}</td>
					</tr>
				</tbody>
			</table>
			<div *ngIf="(exportSummary?.totalRegistros || 0) === 0" class="alert alert-warning py-2 mb-2">
				No hay documentos para exportar con los filtros actuales.
			</div>
		</div>

		<div class="text-muted">
			La exportacion puede tardar algunos minutos si el volumen de documentos es alto.
		</div>
	</div>

	<div class="modal-footer d-flex justify-content-end p-3">
		<div>
			<button type="button" class="btn btn-success" [disabled]="!canConfirmGridExport()" (click)="onSubmitWithGridFilters()">
				<span class="d-none d-lg-block">Confirmar exportacion</span>
			</button>
			<button type="button" class="btn btn-secondary ml-3" (click)="closeSummaryModal(modal)">
				<span class="d-none d-lg-block">Cancelar</span>
			</button>
		</div>
	</div>
</ng-template>
